import React from 'react';

export function SellerIcon({width = '20', height = '20', viewBox = '0 0 20 20'}) {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4459_23743)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.50004 5.94265V17.5H17.5V5.94265L15.5328 2.50004H4.46724L2.50004 5.94265ZM3.50004 0.833374L0.833374 5.50004V19.1667H19.1667V5.50004L16.5 0.833374H3.50004Z"
          fill="black"
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M2.5 8.33337V10H17.5V8.33337H2.5Z" fill="black" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.40592 7.05131C4.06156 7.05131 3.78178 7.33108 3.78178 7.67546V9.13295H2.11511V7.67546C2.11511 6.41062 3.14107 5.38464 4.40592 5.38464C5.67076 5.38464 6.69675 6.41061 6.69675 7.67546V9.13295H5.03009V7.67546C5.03009 7.3311 4.7503 7.05131 4.40592 7.05131Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.05009 7.05131C7.70573 7.05131 7.42594 7.33109 7.42594 7.67547V9.13296H5.75928V7.67547C5.75928 6.41062 6.78524 5.38464 8.05009 5.38464C9.31493 5.38464 10.3409 6.41061 10.3409 7.67547V9.13296H8.67426V7.67547C8.67426 7.3311 8.39447 7.05131 8.05009 7.05131Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.6936 7.05131C11.3493 7.05131 11.0695 7.33109 11.0695 7.67547V9.13296H9.40283V7.67547C9.40283 6.41062 10.4288 5.38464 11.6936 5.38464C12.9585 5.38464 13.9845 6.41061 13.9845 7.67547V9.13296H12.3178V7.67547C12.3178 7.3311 12.038 7.05131 11.6936 7.05131Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.3377 7.05131C14.9933 7.05131 14.7135 7.33108 14.7135 7.67546V9.13295H13.0469V7.67546C13.0469 6.41062 14.0728 5.38464 15.3377 5.38464C16.6025 5.38464 17.6285 6.41061 17.6285 7.67546V9.13295H15.9618V7.67546C15.9618 7.3311 15.6821 7.05131 15.3377 7.05131Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.6667 15H8.33341V17.5H11.6667V15ZM6.66675 13.3334V19.1667H13.3334V13.3334H6.66675Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_4459_23743">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
